import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { User } from '../../../shared/models/user.model';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SettingService } from '../../services/setting.service';
import { CookieService } from 'ngx-cookie-service';
import { sidebarCollpasedMenu } from '../../../core/helpers/app.helper';
import { environment } from '../../../../environments/environment';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {
    public scrollConfig: PerfectScrollbarConfigInterface = {};
    private apiUrl = environment.apiUrl;

    @Input() settings: any;
    menuItems: any[] = [];
    loginUser: User;
    permissionsArray: string[] = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService,
        private settingService: SettingService,
        private cookieService: CookieService,
        public ngxRolesService: NgxRolesService,
        public ngxPermissionsService: NgxPermissionsService,
    ) {
        const sidebarData = this.route.snapshot.data.sidebarMenu;

        // set logged in user
        this.loginUser = sidebarData.loginUser;
        console.log("loginn userrr " , this.loginUser)
        this.authenticationService.setLoginUser(this.loginUser);

        // normalize permissions to string array
        this.permissionsArray = this.normalizePermissions(this.loginUser.permissions, this.loginUser.roles);

        // filter menus by permission
        const rawMenus = sidebarData.menus || [];
        this.menuItems = this.filterMenusByPermission(rawMenus, this.permissionsArray);
        // localStorage.setItem('menuItems', JSON.stringify(this.loginUser.permissions));
        // localStorage.setItem('permissions', JSON.stringify(this.permissionsArray));

    }



    ngOnInit() { }

    ngAfterViewInit() {
        setTimeout(() => {
            sidebarCollpasedMenu();
        });
    }

    logout() {
        this.authenticationService.logout();
    }

    /**
     * Normalize permissions into a flat string array
     */
    private normalizePermissions(permissions: any, roles: any): string[] {
        if (!permissions) return [];

        let roleKey: string | null = roles && roles.length ? roles[0] : Object.keys(permissions)[0];
        let perms: any = roleKey && permissions[roleKey] ? permissions[roleKey] : permissions;

        if (Array.isArray(perms)) return perms.map(p => String(p));
        if (typeof perms === 'object') return Object.keys(perms).filter(k => perms[k] === true || perms[k] === 'true');
        if (typeof perms === 'string') return perms.split(',').map(p => p.trim()).filter(Boolean);

        return [];
    }

    /**
     * Check if user has permission for a menu
     */
    hasPermission(label: string): boolean {
        if (!label) return true;
        const key = label.toLowerCase() + '_view';
        return this.permissionsArray.includes(key);
    }

    /**
     * Filter menus and submenus using permissions
     */
    filterMenusByPermission(menus: any[], permissions: string[]): any[] {
        return menus
            .map(menu => {
                // filter submenu first
                if (menu.submenu && menu.submenu.length > 0) {
                    menu.submenu = menu.submenu.filter(sub => this.hasPermission(sub.label));
                }

                // show parent if it has permission or has visible children
                const parentAllowed = this.hasPermission(menu.label);
                if (parentAllowed || (menu.submenu && menu.submenu.length > 0)) return menu;

                return null;
            })
            .filter(menu => menu !== null);
    }

    /**
     * Check if any child of this parent menu is active
     */
    isMenuActive(menuItem: any): boolean {
        // ✅ Case 1: Parent has children → check if any child route is active
        if (menuItem.submenu && menuItem.submenu.length > 0) {
            return menuItem.submenu.some(sub =>
                this.router.isActive(sub.link, true)
            );
        }

        // ✅ Case 2: Parent has NO children → check its own route
        if (menuItem.link && menuItem.link !== '#') {
            return this.router.isActive(menuItem.link, true);
        }

        return false;
    }
}
